import React, { PropsWithChildren } from 'react';
import { InitMixpanel } from '@ygtechnologies/bygr-frontend-tools';
import I18nLoader from './components/app/I18nLoader';
import { useCurrentCulture } from '@/utils/hooks';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { DefaultCulture } from '@/utils/localization';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export interface TopLevelProvidersProps extends PropsWithChildren {}

const queryClient = new QueryClient();

const ReactQueryDevtools = import.meta.env.DEV
    ? React.lazy(() =>
          import('@tanstack/react-query-devtools').then((m) => ({
              default: m.ReactQueryDevtools,
          })),
      )
    : null;

export const TopLevelProviders: React.FC<TopLevelProvidersProps> = ({ children }) => {
    const [cultureInfo] = useCurrentCulture();

    return (
        <QueryClientProvider client={queryClient}>
            <Router>
                <I18nLoader language={cultureInfo ?? DefaultCulture}>
                    <InitMixpanel
                        token={window['APP_CONFIG']['MIXPANEL_TOKEN']}
                        environment={window['APP_CONFIG']['ENVIRONMENT']}
                        application="CM"
                        Loader={LoadingIndicator}>
                        {children}
                    </InitMixpanel>
                </I18nLoader>
            </Router>
            {ReactQueryDevtools && (
                <React.Suspense fallback={null}>
                    <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
                </React.Suspense>
            )}
        </QueryClientProvider>
    );
};
